<template>
	<div class="no-results-content">
		<p class="warning-text">{{ noResultsText }}</p>
		<button 
			class="dc-button dc-button--type-secondary" 
			@click.stop.prevent="showQuestionForm()">Send oss et nytt spørsmål</button>
	</div>
</template>

<script>
export default {
	props: {
		noResultsText: {
			type: String,
			required: true,
		},
	},
	methods: {
		showQuestionForm() {
			this.$emit('showQuestionForm')
		}
	}
};
</script>
